/**
 * Created by Alican Köker on 2019-09-09.
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { IResizeData } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { TimelineLite } from "gsap";
import { EdisonGameConfig } from "../../EdisonGameConfig";
import { EdisonHelper } from "../../../utils/EdisonHelper";

export class EdisonFreespinSwoopOverlay extends BaseView {

    private _swooshNames:string[] = ["Black", "White", "Red", "Purple", "Blue", "Green"];
    private _swooshSpine:PIXI.spine.Spine;
    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _blinkSpineContainerSprite:PIXI.Sprite;

    constructor() {
        super();

        this._blinkSpineContainerSprite = new PIXI.Sprite();
    }

    protected initAnimations():void {
        this.initSwoosh();
    }

    private initSwoosh():void {
        this._swooshSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("shineSpine"));
        this._swooshSpine.tint = 0xff75ff;

        this.addChild(this._swooshSpine);
        this.addChild(this._blinkSpineContainerSprite);
    }

    protected onResize(resizeData:IResizeData):void {
        this.reposition(resizeData.orientation);
        this._orientation = resizeData.orientation;
    }

    private reposition(orientation:Orientation, init:Boolean = false):void {
        if(orientation === Orientation.LANDSCAPE) {
            this._swooshSpine.position.set(638, 314);
        } else {
            this._swooshSpine.position.set(640, 210);
        }
    }

    public playSwooshAnimByColor(featureSymbolIndex:number):void {
        let animName:string = "SweepBBG";

        if(this._orientation === Orientation.PORTRAIT) {
            animName = "SweepPort";
        } else {
            if(featureSymbolIndex === 1 || featureSymbolIndex === 2 || featureSymbolIndex === 3)
                animName = "SweepWRP"
        }

        this._swooshSpine.skeleton.setSkinByName(this._swooshNames[featureSymbolIndex]);

        this._swooshSpine.state.setAnimation(0, animName, false);
    }

    public playBlinkAnimation(reelIndex:number, symbolIndex:number, skin:string):TimelineLite {

        const symW:number = EdisonGameConfig.instance.SYMBOL_WIDTH;
        const symH:number = EdisonGameConfig.instance.SYMBOL_HEIGHT;

        let blinkSpine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("blinkSpine"));

        blinkSpine.skeleton.setSkinByName(skin);

        this._blinkSpineContainerSprite.addChild(blinkSpine);

        let pos:number[] = EdisonHelper.getSymbolPosition(reelIndex, symbolIndex);

        let diff:number = this._orientation === Orientation.PORTRAIT ? -100 : 0;

        blinkSpine.position.set(pos[0] + symW / 2, pos[1] + diff + symH / 2);

        let tl:TimelineLite = new TimelineLite();

        tl.add(() => {

            let entry:PIXI.spine.core.TrackEntry = blinkSpine.state.setAnimation(0, "GoldBlink", false);
            entry.timeScale = 2;
        });

        return tl;
    }
}